import { render, staticRenderFns } from "./Presupuestos.vue?vue&type=template&id=9a0eb978&scoped=true&"
import script from "./Presupuestos.vue?vue&type=script&lang=js&"
export * from "./Presupuestos.vue?vue&type=script&lang=js&"
import style0 from "./Presupuestos.vue?vue&type=style&index=0&id=9a0eb978&scoped=true&lang=css&"
import style1 from "./Presupuestos.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0eb978",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VDataTable,VForm,VProgressLinear,VRadio,VRadioGroup,VRow,VSelect,VTextField})
